import React, { useRef, useState, useEffect } from "react";
import OVERLAY_IMAGE from "../../assets/dbc_overlay.png";
import "./VideoPage.css";

const VideoPage = (props) => {
  const headerRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);
  const [showGradient, setShowGradient] = useState(true);

  const field = (fieldName) => props?.dataSource?.[fieldName];

  useEffect(() => {
    const overlayTimer = setTimeout(() => {
      setShowOverlay(false);
    }, 14000);

    const gradientTimer = setTimeout(() => {
      setShowGradient(false);
    }, 14000);
    return () => {
      clearTimeout(overlayTimer);
      clearTimeout(gradientTimer);
    };
  }, []);

  const handleScrollToHeader = () => {
    headerRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className="video-container">
        <iframe
          className="youtube-background"
          src={field("videoUrl")}
          // src="https://www.youtube.com/embed/GEmWo8CPFqI?autoplay=1&mute=1&loop=1&playlist=GEmWo8CPFqI&controls=0&showinfo=0&rel=0&modestbranding=1"
          title="Background Video"
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
        ></iframe>
        <div
          className={`video-container ${
            showGradient ? "gradient-background" : ""
          }`}
        >
          {showOverlay && (
            <div className="overlay">
              <img
                // src={OVERLAY_IMAGE}
                // src="https://anjac.edu.in/files_list/anjac/fm/Untitled_design__9_-removebg-preview.png"
                alt=""
                style={{ width: "100%", maxWidth: "1200px" }}
              />
            </div>
          )}
        </div>
      </div>
      <button className="scroll-button" onClick={handleScrollToHeader}>
        <i
          className="fa fa-home text-white me-2 p-2 rounded-circle"
          style={{ backgroundColor: "#432971" }}
        ></i>{" "}
        Scroll to Home
      </button>

      <div ref={headerRef}></div>
    </>
  );
};

export default VideoPage;
